var ReportingTreejson = [
  // {
  //     id: '1',
  //     label: 'Creation',
  //     pagename: 'Creation',
  //     children: [],
  //     child: [
  //         {
  //             id: '4',
  //             label: 'Template Group',
  //             pagename: 'TemplateGroup',
  //             children: [],
  //             child: []
  //         }
  //     ]
  // },
  {
    id: "2",
    label: "Generation",
    pagename: "Generate",
    children: [],
    child: [
      {
        id: "5",
        label: "Generate",
        pagename: "Generate",
        children: [],
        child: [],
      },
      {
        id: "6",
        label: "Generated Reports",
        pagename: "View",
        children: [],
        child: [],
      },
    ],
  },
  // {
  //     id: '3',
  //     label: 'Scheduler',
  //     pagename: 'Scheduler',
  //     children: [],
  //     child: [
  //         {
  //             id: '7',
  //             label: 'Schedule',
  //             pagename: 'Scheduler',
  //             children: [],
  //             child: []
  //         },
  //     ]
  // },
];

export default ReportingTreejson;
